export default "__VITE_ASSET__Co4W5XbX__"